import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Smartphone, TrendingUp } from 'lucide-react';
import { useLang } from '../i18n/LangContext';

const ICONS = [<Globe size={40} />, <TrendingUp size={40} />, <Smartphone size={40} />];

const Services = () => {
	const { t } = useLang();
	const services = t.services.items.map((item, i) => ({ ...item, icon: ICONS[i] }));

	return (
		<section id="services" className="py-24 bg-white">
			<div className="container mx-auto px-6">
				<div className="text-center mb-16">
					<h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">{t.services.heading}</h2>
					<p className="text-lg text-slate-600 max-w-2xl mx-auto">
						{t.services.subheading}
					</p>
				</div>

				<div className="grid md:grid-cols-3 gap-8 lg:gap-12">
					{services.map((service, index) => (
						<motion.div
							key={index}
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ delay: index * 0.2 }}
							className="p-8 rounded-2xl bg-slate-50 hover:bg-white hover:shadow-xl transition-all duration-300 border border-slate-100 group"
						>
							<div className="mb-6 text-blue-600 group-hover:scale-110 transition-transform duration-300">
								{service.icon}
							</div>
							<h3 className="text-xl font-bold text-slate-900 mb-3">{service.title}</h3>
							<p className="text-slate-600 leading-relaxed">
								{service.description}
							</p>
						</motion.div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Services;
